import { useFormik } from "formik";
import * as yup from "yup";
import { validationMessages } from "../types/validation-messages";
import { useState } from "react";
import { TrainingCenterForm } from "../components/contact-form/training-form";
import { postTrainingCenterFormData } from "../services/api";
import { showErrorToast } from "../services/toast";

export const TrainingCenterFormContainer: React.FC = () => {
  const [dropdownOpen, setDropdownOpen] = useState<boolean[]>([false]);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [viewportWidth, setviewportWidth] = useState(window.innerWidth);

  const handleDropdownToggle = (dropdownValues: boolean[], index: number) => {
    const newValues = dropdownValues;
    newValues[index] = !newValues[index];
    setDropdownOpen([...newValues]);
  };

  const validation = yup.object().shape({
    type: yup
      .string()
      .required(validationMessages.FIELD_REQUIRED)
      .max(50, validationMessages.TOO_MANY_CHARACTERS_INPUT),
    week: yup
      .string()
      .required(validationMessages.FIELD_REQUIRED)
      .max(50, validationMessages.TOO_MANY_CHARACTERS_INPUT),
    language: yup
      .string()
      .required(validationMessages.FIELD_REQUIRED)
      .max(50, validationMessages.TOO_MANY_CHARACTERS_INPUT),
    company: yup
      .string()
      .required(validationMessages.FIELD_REQUIRED)
      .max(50, validationMessages.TOO_MANY_CHARACTERS_INPUT),
    email: yup
      .string()
      .required(validationMessages.FIELD_REQUIRED)
      .matches(
        /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
        validationMessages.EMAIL_NOT_VALID
      )
      .max(50, validationMessages.TOO_MANY_CHARACTERS_INPUT),
    phoneNumber: yup
      .string()
      .required(validationMessages.FIELD_REQUIRED)
      .max(50, validationMessages.TOO_MANY_CHARACTERS_INPUT),
    participants: yup
      .array()
      .of(yup.string().max(50, validationMessages.TOO_MANY_CHARACTERS_INPUT)),
    message: yup
      .string()
      .max(1000, validationMessages.TOO_MANY_CHARACTERS_TEXTAREA),
  });

  const formik = useFormik({
    initialValues: {
      type: "",
      week: "",
      language: "",
      company: "",
      email: "",
      phoneNumber: "",
      message: "",
      participants: [""],
      experiences: ["NONE"],
      captchaToken: "",
    },
    validationSchema: validation,
    onSubmit: (values) => {
      setFormSubmitting(true);
      postTrainingCenterFormData(values)
        .then(() => (window.location.href = "/kontakt/success"))
        .catch((error) => showErrorToast(error))
        .finally(() => setFormSubmitting(false));
    },
  });

  const addParticipant = () => {
    const participants = formik.values.participants;
    const experiences = formik.values.experiences;
    participants.push("");
    experiences.push("NONE");
    formik.setFieldValue("participants", [...participants]);
    formik.setFieldValue("experiences", [...experiences]);
  };

  const removeParticipant = (id: number) => {
    const participants = formik.values.participants;
    const experiences = formik.values.experiences;
    experiences.splice(id, 1);
    participants.splice(id, 1);
    formik.setFieldValue("participants", [...participants]);
    formik.setFieldValue("experiences", [...experiences]);
  };

  const changeParticipantName = (id: number, value: string) => {
    const participants = formik.values.participants;
    participants[id] = value;
    formik.setFieldValue("participants", [...participants]);
  };

  const changeParticipantExperience = (id: number, value: string) => {
    const experiences = formik.values.experiences;
    experiences[id] = value;
    formik.setFieldValue("experiences", [...experiences]);
  };

  window.addEventListener("resize", () => {
    setviewportWidth(window.innerWidth);
  });

  return (
    <TrainingCenterForm
      dropdownsOpen={dropdownOpen}
      onDropdownToggle={handleDropdownToggle}
      addParticipant={addParticipant}
      removeParticipant={removeParticipant}
      changeParticipantName={changeParticipantName}
      changeParticipantExperience={changeParticipantExperience}
      onSubmit={formik.handleSubmit}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      values={formik.values}
      touched={formik.touched}
      errors={formik.errors}
      setFieldValue={formik.setFieldValue}
      formSubmiting={formSubmitting}
      viewportWidth={viewportWidth}
    />
  );
};
